/**
 * LA TRIBUNA — Force product card images visibility
 * Solución JS de respaldo para el problema de imágenes ocultas en colección
 */
(function() {
  'use strict';
  
  function forceImageVisibility() {
    try {
      // Selector amplio para todas las cards de producto
      const cards = document.querySelectorAll(
        '.card-gallery, [ref="cardGallery"], .product-grid__card, .product-grid__item'
      );
      
      cards.forEach(card => {
        // Forzar slideshow-slide visible (la primera y la activa)
        const slides = card.querySelectorAll('slideshow-slide');
        slides.forEach((slide, i) => {
          if (i === 0 || slide.getAttribute('aria-hidden') === 'false') {
            slide.style.cssText += '; content-visibility: visible !important; opacity: 1 !important; visibility: visible !important;';
          }
        });
        
        // Forzar todas las imágenes visibles
        const imgs = card.querySelectorAll('img');
        imgs.forEach(img => {
          img.style.cssText += '; opacity: 1 !important; visibility: visible !important; display: block !important;';
          
          // Si la imagen tiene loading lazy y no se ha cargado, forzarla a eager
          if (img.loading === 'lazy' && !img.complete) {
            img.loading = 'eager';
          }
          
          // Si la imagen falla, intentar cargarla de nuevo
          if (img.complete && img.naturalWidth === 0) {
            const src = img.src;
            img.src = '';
            img.src = src;
          }
        });
      });
    } catch (e) {
      console.warn('lt-image-fix:', e);
    }
  }
  
  // Ejecutar inmediatamente
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceImageVisibility);
  } else {
    forceImageVisibility();
  }
  
  // Ejecutar después de window.load
  window.addEventListener('load', forceImageVisibility);
  
  // MutationObserver para productos cargados dinámicamente (paginación, filtros)
  const observer = new MutationObserver((mutations) => {
    let needsFix = false;
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches && (
            node.matches('.product-grid__item') ||
            node.matches('.product-grid__card') ||
            node.matches('slideshow-slide') ||
            node.matches('.card-gallery')
          )) {
            needsFix = true;
          }
          if (node.querySelector && node.querySelector('.card-gallery, slideshow-slide, .product-grid__item')) {
            needsFix = true;
          }
        }
      });
    });
    if (needsFix) {
      requestAnimationFrame(forceImageVisibility);
    }
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
  
  // También tras eventos de cambio de vista del grid
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[product-grid-view], [data-view]')) {
      setTimeout(forceImageVisibility, 100);
      setTimeout(forceImageVisibility, 500);
    }
  });
  
  // Re-ejecutar cada cierto tiempo durante los primeros segundos
  setTimeout(forceImageVisibility, 500);
  setTimeout(forceImageVisibility, 1500);
  setTimeout(forceImageVisibility, 3000);
})();
